import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27edbba7")

_pushScopeId("data-v-27edbba7")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group alignC" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_4 = { class: "form" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "天", -1)
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "元", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "元", -1)
const _hoisted_9 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "c-90 f-12" }, " 只能上传 jpg/png 文件，且不超过 500kb(分辨率为370*165) ", -1)
const _hoisted_11 = {
  id: "editor",
  ref: "editorRef"
}
const _hoisted_12 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center","margin-top":"192px"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "提交", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_4, [
      _withDirectives(_createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        "label-width": "120px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            class: "flex-1",
            label: "尊享卡名称",
            prop: "title"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                style: {"width":"278px"},
                modelValue: _ctx.form.title,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.title = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "有效期",
            prop: "end_time"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                type: "number",
                style: {"width":"278px"},
                modelValue: _ctx.form.end_time,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.end_time = $event)),
                modelModifiers: { number: true }
              }, {
                suffix: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "适用门店",
            prop: "store_ids"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.store_ids,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.store_ids = $event)),
                multiple: "",
                placeholder: ""
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.store_ids, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.store_name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "flex-1",
            label: "库存",
            prop: "stock_number"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                class: "wh-100-40 mar-lr-9",
                modelValue: _ctx.form.stock_number,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.stock_number = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "显示在用户端",
            "label-width": "120px"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_checkbox, {
                "true-label": 1,
                "false-label": 0,
                modelValue: _ctx.form.is_show,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.is_show = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_el_form_item, {
              class: "flex-1",
              label: "价格",
              prop: "price"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  type: "number",
                  class: "wh-100-40 mar-lr-9",
                  modelValue: _ctx.form.price,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.price = $event)),
                  modelModifiers: { number: true }
                }, {
                  suffix: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_form_item, {
            class: "flex-1",
            label: "销售提成"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                type: "number",
                class: "wh-100-40 mar-lr-9",
                modelValue: _ctx.form.percentage,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.percentage = $event)),
                modelModifiers: { number: true }
              }, {
                suffix: _withId(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "卡片背景图",
            prop: "backgroundimg"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_upload, {
                class: "upload",
                action: "https://jsonplaceholder.typicode.com/posts/",
                "before-upload": _ctx.beforeAvatarUpload,
                multiple: "",
                limit: 3,
                "on-change": 
                            (file) => {
                                _ctx.handleChange(file);
                            }
                        
              }, {
                default: _withId(() => [
                  (_ctx.form.backgroundimg)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: _ctx.form.backgroundimg,
                        class: "avatar"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock("i", _hoisted_9))
                ]),
                _: 1
              }, 8, ["before-upload", "on-change"]),
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "备注" }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                rows: 2,
                placeholder: "请输入内容",
                modelValue: _ctx.form.vice_title,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.vice_title = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "详情" }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_11, null, 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.form_load]
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx.onSubmit
      }, {
        default: _withId(() => [
          _hoisted_13
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withId(() => [
          _hoisted_14
        ]),
        _: 1
      })
    ])
  ]))
})